goog.provide("shadow.js.shim.module$$js_temporal$polyfill$Temporal_Duration");
shadow.js.shim.module$$js_temporal$polyfill$Temporal_Duration = shadow.js.require(1, {})["Temporal"]["Duration"];
